import { render, staticRenderFns } from "./ApproversModal.vue?vue&type=template&id=69dff96e"
import script from "./ApproversModal.vue?vue&type=script&lang=js"
export * from "./ApproversModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports